import React, { FC, useEffect } from 'react'
import { io } from 'socket.io-client'
import { NotificationPlacement } from 'antd/es/notification/interface'
import { LikeOutlined, DislikeOutlined, StopOutlined } from '@ant-design/icons'
import { entries, entriesApprovedEnum } from '../../../types/entries'
import { ConfigProvider, notification } from 'antd'
import { typeQrEnumStringCheckPointCentral } from '../../../types/qr'
import { useAudio, SoundKey } from '../../../Provider/AudioProvider'
import './style.scss'
import moment from 'moment'

type NotificationsProps = {
  userId: string | undefined
  setNewEntrySocket?: (entry: entries) => void
}

// Mapea el "values" del QR a la familia de sonidos correspondiente.
const SOUND_PREFIX: Record<string, 'INVITADO' | 'RESIDENTE' | 'TRABAJADOR'> = {
  VISITANTE: 'INVITADO',
  INVITADO: 'INVITADO',
  RESIDENTE: 'RESIDENTE',
  'RESIDENTE D': 'RESIDENTE',
  TRABAJADOR: 'TRABAJADOR',
  PERSONAL: 'TRABAJADOR'
}

const SocketReadQr: FC<NotificationsProps> = ({ userId, setNewEntrySocket }) => {
  const [api, contextHolder] = notification.useNotification({ stack: { threshold: 1 } })
  const { play } = useAudio()

  const positionsStylesSvg: React.CSSProperties | undefined = {
    position: 'fixed',
    fontSize: '40px',
    bottom: '30%',
    right: '30px'
  }

  useEffect(() => {
    const socketWhats = io(process.env.REACT_APP_API_URL_BACKEND)
    socketWhats.on(
      `readQr-${userId}`,
      ({ entry, valid, message }: { entry?: entries; valid: boolean; message?: string }) => {
        if (!entry) {
          api.open({
            message: (
              <span className="containerBan">
                <h3> {message || `CÓDIGO DESCONOCIDO`} </h3>
                <div className="timeTapReadQr">{moment().format('h:mm a')}</div>
                <StopOutlined
                  style={{
                    color: 'red',
                    position: 'fixed',
                    fontSize: '40px',
                    bottom: '15%',
                    right: '42%',
                    backgroundColor: '#263371'
                  }}
                />
              </span>
            ),

            placement: 'topRight' as NotificationPlacement,
            duration: 10,
            showProgress: true,
            pauseOnHover: true,
            className: 'SocketsreactQR',
            style: {
              width: '370px',
              backgroundColor: '#263371',
              padding: '10px',
              height: '115px',
              borderRadius: '20px'
            }
          })

          play('CODIGO_DESCONOCIDO')
          return
        }

        const type = entry.qrCode?.slice(
          0,
          4
        ) as keyof typeof typeQrEnumStringCheckPointCentral

        const values = typeQrEnumStringCheckPointCentral[type]

        api.open({
          message: (
            <span className="containerBan">
              <h3> {`${values} ${valid ? 'AUTORIZADO' : 'NO AUTORIZADO'} `} </h3>
              <div className="containerData">
                <div style={{ width: '70%' }}>
                  <h5>
                    {entry.name} {entry.lastName ? `${entry.lastName}` : ''}
                  </h5>
                </div>

                <div>
                  <p> {entry.destination ? `DESTINO:${entry.destination}` : ''}</p>
                  <p> {entry.namesResident ? `RESIDENTE:${entry.namesResident}` : ''}</p>
                </div>
              </div>
              <div className="timeTapReadQr">{moment().format('h:mm a')}</div>
              {valid && (
                <LikeOutlined
                  style={{
                    color: '#f600c0',
                    backgroundColor: '#263371',
                    ...positionsStylesSvg
                  }}
                />
              )}
              {!valid && (
                <DislikeOutlined
                  style={{
                    color: 'red',
                    backgroundColor: '#263371',
                    ...positionsStylesSvg
                  }}
                />
              )}
            </span>
          ),

          placement: 'topRight' as NotificationPlacement,
          duration: 10,
          showProgress: true,
          pauseOnHover: true,
          className: 'SocketsreactQR',
          style: {
            width: '370px',
            backgroundColor: '#263371',
            padding: '10px',
            borderRadius: '20px'
          }
        })

        const prefix = SOUND_PREFIX[values]
        if (prefix) {
          const key = `${prefix}_${valid ? 'AUTORIZADO' : 'NO_AUTORIZADO'}` as SoundKey
          play(key)
        }

        entry.approved = valid ? entriesApprovedEnum.APPROVED : entriesApprovedEnum.REJECT

        if (setNewEntrySocket) setNewEntrySocket(entry)
      }
    )

    return () => {
      socketWhats.disconnect()
    }
  }, [userId, setNewEntrySocket])

  return (
    <ConfigProvider
      theme={{
        token: {
          colorInfo: '#5b1fca',
          colorPrimary: '#5b1fca',
          colorInfoText: '5b1fca',
          colorLink: '5b1fca',
          colorPrimaryText: '5b1fca'
        }
      }}
    >
      {contextHolder}
    </ConfigProvider>
  )
}

export default SocketReadQr
